import * as React from 'react';
import Box from '@mui/material/Box';
import {BpSection} from "../components/cardDetails/BpSection";
import {OverallReadingsSection} from "../components/cardDetails/OverallReadingsSection";
import {LineChartComponent} from "../components/Charts/LineChartComponent";
import {DetailsTable} from "../components/cardDetails/DetailsTable";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import services from "../services";
import {RoutesList} from "../Modules/RoutesList";
import {styled, Typography} from "@mui/material";
import {DataGrid, GridColDef, GridColumns, GridValueGetterParams} from "@mui/x-data-grid";
import {blue, green, red} from "@mui/material/colors";
import {useSelector} from "react-redux";
import {RootState} from "../app/store";


export interface Areas{
    property : string,
    color : string
}

const RootChart = styled('div')(({ theme }) => ({
     padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
        width:250
        // backgroundColor: red[500],
    },
    [theme.breakpoints.up('sm')]: {
        width:300
        // backgroundColor: red[500],
    },
    [theme.breakpoints.up('md')]: {
        width:'100%'
        // backgroundColor: blue[500],
    },
    [theme.breakpoints.up('lg')]: {
        width:'100%'
        // backgroundColor: green[500],
    },
}));

export const  Details = () => {
    let params = useParams();

    const auhUser = useSelector(((state:RootState) => state.auth.user))

   const [DateValue, setDateValue] = React.useState<any>(null);

    const [chartData,setChartData] = useState<any>([])

    const [tableData,setTableData] = useState<any>([])

    const [activeLink,setActiveLink] = useState<string>('Year')

    const [readingSkeleton,setReadingSkeleton] = useState<boolean>(true)

    const [overAllReadingsSkeleton,setOverallReadingsSkeleton]  = useState<boolean>(true)

    const [tableskeleton,setTableSkeleton] = useState<boolean>(true)

    const [devices,setDevices] = useState([])

    const [currentdevice,setCurrentDevice] = useState<string>(params['id']!)

    const [columns,setColumns] = useState<GridColumns>([])

    const [areas,setAreas] = useState<Areas[]>([])

    const navigator = useNavigate()
    const user = localStorage.getItem("token")
    useEffect(()=>{
            if(!user)
                navigator(RoutesList.Login.path)

        let _devices = JSON.parse(localStorage.getItem('devices')!)
        let _categories = JSON.parse(localStorage.getItem('categories')!)
        // setDevices(_devices.filter((d:any) =>d.category_id === _categories.filter((c:any) =>c.name === params['catName'])[0].id))
    },[])

    useEffect(()=>{
        if(activeLink.length>0){
            setDateValue(null)
        }
    },[activeLink])

    useEffect(()=>{
        if(user && activeLink.length===0)
        fetchReadings()
    },[DateValue,currentdevice])

    useEffect(()=>{
        if(activeLink.length>0)
                fetchReadingsBychips()
    },[activeLink,currentdevice])

    useEffect(()=>{
        if(chartData.length>0)
        setOverallReadingsSkeleton(false)
    },[chartData])

    const fetchReadingsBychips = () =>{
        setReadingSkeleton(true)
        setTableSkeleton(true)
        services.GetChartData({
            mode:activeLink,
            deviceID:currentdevice,
            category:params["catName"]!,
            zone:-(new Date().getTimezoneOffset() / 60),
            userID : params["uuid"]!
        })
            .then(res=>{
                    setChartData(res.data)
                    setReadingSkeleton(false)
                setTableData(res.data)
                setTableSkeleton(false)
                setOverallReadingsSkeleton(false)

                if(res.data.length) {
                    prepareColumns(res.data[0])
                    prepareAreas(res.data[0])
                }
            })
            .catch(err=> {
                setOverallReadingsSkeleton(false)
            })
    }


    const fetchReadings = () =>{

        setReadingSkeleton(true)
        setTableSkeleton(true)


        services.getReadings({
            date: `${DateValue}`,
            imei :currentdevice,
            category_name:params["catName"]!,
            timeZone : -(new Date().getTimezoneOffset() / 60),
            userID : params["uuid"]!
            },
        )
            .then(e=>{
                setChartData(e.data.graphData)
                setTableData(e.data.readings)
                setReadingSkeleton(false)
                setTableSkeleton(false)
                setOverallReadingsSkeleton(false)

                if(e.data.readings.length) {
                    prepareColumns(e.data.readings[0])
                    prepareAreas(e.data.graphData[0])
                }
            })
            .catch(error=>{
                setOverallReadingsSkeleton(false)
            })
    }

    const prepareColumns = (data:any) =>{
        let _col : GridColumns = []
        delete data.t

        Object.keys(data).map((r:string)=>{
            _col.push(
                {
                    field: r,
                    headerName: r,
                    minWidth: 110,
                    flex: 1,align: 'center',
                    headerAlign: 'center',

                })
        })
        setColumns(_col)
    }

    const prepareAreas = (data:any) =>{
        let _area : Areas[] = []
        let colors = ['#266945FF','#16abe7','red']
        let {ReadingID,Week,Month,Day,Year,t,date,epoch,...rest} = data
        Object.keys(rest).map((r:string,index)=>{
            _area.push({property:r,color:colors[index]})
        })
        setAreas(_area)
    }

    const getRandomColor = () => {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }


    return (
        <Box sx={{ flexGrow: 1,padding:"0px 30px" }}>
            <Typography
                fontSize={32}
                fontWeight={700}
                color="#081735"
                paddingTop={1}
                paddingBottom={4}
            >
                {params["catName"]?.replaceAll('_',' ')}
            </Typography>
           <BpSection />
            <OverallReadingsSection value = {DateValue} setValue ={setDateValue} devices={devices} setCurrentDevice={setCurrentDevice} setActiveLink = {setActiveLink} skeleton = {overAllReadingsSkeleton}/>
            <RootChart>
                {
                    chartData.length && areas.length ?
                        <LineChartComponent
                            data={chartData}
                            chips={activeLink}
                            skeleton = {readingSkeleton}
                            startDate={`${DateValue}T00:00:00.000Z`.split('T')[0] +' '+ '12:00 AM'}
                            endDate={`${DateValue}T23:59:59.999Z`.split('T')[0] +' '+ '23:59'}
                            areas={areas}
                        />
                        :''
                }
            </RootChart>
            <DetailsTable tableData={tableData} duration = {activeLink} skeleton={tableskeleton} tableColumns={columns}/>
        </Box>
    );
}

//2022-05-01 06:48:47.0000000 +05:00


